<script setup>
defineProps({ blok: Object });
</script>

<template>
  <img
    v-if="blok.image.filename"
    :src="blok.image.filename"
    :alt="blok.image.alt"
    class="mb-2"
  />
</template>
